import React from 'react';
import PropTypes from 'prop-types';

import { SellPageLinks } from '../NavItems/SellPageLinks';
import { LoginLink } from '../NavItems/LoginLink';

export const UnsubscribedUserNav = ({ hasSearchBar, isLivePage, isGoPage, isLoggedIn, isSearchPage }) => (
  <>
    {!isLivePage && !isGoPage && <SellPageLinks hasSearchBar={hasSearchBar} isSearchPage={isSearchPage} />}
    {!isLoggedIn && !isGoPage && <LoginLink />}
  </>
);

UnsubscribedUserNav.propTypes = {
  hasSearchBar: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isGoPage: PropTypes.bool,
  isSearchPage: PropTypes.bool,
};
